define('replay/geometry',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        wingsuit: function () {
            var geometry = new THREE.Geometry();
            geometry.vertices.push(new THREE.Vector3(0, 0.1, 0.3), // 0 Chest
            new THREE.Vector3(0, -0.1, 0.3), // 1 Back
            new THREE.Vector3(0, 0.1, -0.3), // 2 Crotch
            new THREE.Vector3(0, -0.1, -0.3), // 3 Butt
            new THREE.Vector3(-0.5, 0, -0.9), // 4 Foot
            new THREE.Vector3(-0.4, 0, -1), // 5 Tail
            new THREE.Vector3(0.4, 0, -1), // 6 Tail
            new THREE.Vector3(0.5, 0, -0.9), // 7 Foot
            new THREE.Vector3(0.5, 0, -0.02), // 8 Wingroot
            new THREE.Vector3(0.7, 0, 0), // 9 Gripper
            new THREE.Vector3(0.7, 0, 0.3), // 10 Wrist
            new THREE.Vector3(0.16, 0, 0.6), // 11 Neck
            new THREE.Vector3(-0.16, 0, 0.6), // 12 Neck
            new THREE.Vector3(-0.7, 0, 0.3), // 13 Wrist
            new THREE.Vector3(-0.7, 0, 0), // 14 Gripper
            new THREE.Vector3(-0.5, 0, -0.02) // 15 Wingroot
            );
            geometry.faces.push(new THREE.Face3(3, 4, 5), new THREE.Face3(3, 5, 6), new THREE.Face3(3, 6, 7), new THREE.Face3(3, 7, 8), new THREE.Face3(1, 3, 8), // Inner
            new THREE.Face3(1, 8, 9), new THREE.Face3(1, 9, 10), new THREE.Face3(1, 10, 11), new THREE.Face3(1, 11, 12), new THREE.Face3(1, 12, 13), new THREE.Face3(1, 13, 14), new THREE.Face3(1, 14, 15), new THREE.Face3(3, 1, 15), // Inner
            new THREE.Face3(3, 15, 4));
            // Make it two-sided
            geometry.faces.push(new THREE.Face3(2, 5, 4), new THREE.Face3(2, 6, 5), new THREE.Face3(2, 7, 6), new THREE.Face3(2, 8, 7), new THREE.Face3(2, 0, 8), // Inner
            new THREE.Face3(0, 9, 8), new THREE.Face3(0, 10, 9), new THREE.Face3(0, 11, 10), new THREE.Face3(0, 12, 11), new THREE.Face3(0, 13, 12), new THREE.Face3(0, 14, 13), new THREE.Face3(0, 15, 14), new THREE.Face3(0, 2, 15), // Inner
            new THREE.Face3(2, 4, 15));
            // Make a head sphere
            var headgeometry = new THREE.SphereGeometry(0.2, 16, 12);
            var head = new THREE.Mesh(headgeometry);
            head.position.z = 0.78;
            head.updateMatrix();
            geometry.merge(headgeometry, head.matrix);
            return geometry;
        },
        north: function (font) {
            return new THREE.TextGeometry("N", {
                font: font,
                size: 0.3,
                height: 0.04
            });
        }
    };
});
//# sourceMappingURL=/assets/javascripts/replay/geometry.js.map;
